/**
 * Switch between development and production APIs for this module
 * by swapping comments on the corresponding lines.
 */

// import orderApi from './dev';   // dev
import orderApi from './prod'; // prod

export default orderApi;
